(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-blog-hub"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bd-blog-hub')){
 class BDBlogHub extends HTMLElement{
  connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.entries=new Map();this.page=1;this.active='all';this.buttons=[...this.querySelectorAll('[data-filter]')];this.featured=this.querySelector('.bdb-featured');this.grid=this.querySelector('.bdb-grid');this.loading=this.querySelector('.bdb-loading');this.retry=this.querySelector('.bdb-retry');this.manual=this.dataset.featured;this.size=8;this.addEntries(this.querySelectorAll('.bdb-entry'));const signal=this.abort.signal;this.buttons.forEach(b=>b.addEventListener('click',()=>{this.active=b.dataset.filter;this.page=1;this.render();},{signal}));this.querySelector('[data-page-prev]').addEventListener('click',()=>this.turn(-1),{signal});this.querySelector('[data-page-next]').addEventListener('click',()=>this.turn(1),{signal});this.retry.addEventListener('click',()=>this.load(),{signal});document.addEventListener('shopify:block:select',e=>{const b=e.target.closest('[data-filter]');if(b&&this.contains(b)){this.active=b.dataset.filter;this.page=1;this.render();}},{signal});this.render();this.load();}
  disconnectedCallback(){this.abort?.abort();}
  addEntries(nodes,source){nodes.forEach(n=>{const old=this.entries.get(n.dataset.id);const blog=source||n.dataset.blog||old?.blog||'';let tags=[];try{tags=JSON.parse(n.dataset.tags||'[]').map(x=>x.toLowerCase());}catch{}this.entries.set(n.dataset.id,{id:n.dataset.id,date:Number(n.dataset.date),blog,tags,node:n.cloneNode(true)});});}
  async load(){if(this.busy)return;this.busy=true;this.retry.hidden=true;const sources=[...new Set(this.buttons.flatMap(b=>(b.dataset.sources||'').split('|').filter(Boolean)))];this.loading.hidden=!sources.length;let failed=false;for(const source of sources){try{let path=source;let seen=new Set();while(path){const url=new URL(path,location.origin);if(url.origin!==location.origin)throw Error('Invalid source');url.searchParams.set('section_id','bd-blog-feed');if(seen.has(url.href))throw Error('Repeated page');seen.add(url.href);const res=await fetch(url,{signal:this.abort.signal});if(!res.ok)throw Error('Unavailable');const doc=new DOMParser().parseFromString(await res.text(),'text/html');const feed=doc.querySelector('[data-bd-feed]');if(!feed)throw Error('Missing feed');this.addEntries(feed.querySelectorAll('.bdb-entry'),source);path=feed.dataset.next||'';}}catch(e){if(e.name==='AbortError')return;failed=true;}}
   this.busy=false;this.loading.hidden=true;this.retry.hidden=!failed;if(this.isConnected)this.render();
  }
  render(){this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===this.active)));const button=this.buttons.find(b=>b.dataset.filter===this.active);const sources=(button?.dataset.sources||'').split('|').filter(Boolean);const tags=(button?.dataset.tags||'').split(',').map(x=>x.trim().toLowerCase()).filter(Boolean);let list=[...this.entries.values()].filter(e=>this.active==='all'||(sources.includes(e.blog)&&(!tags.length||tags.some(t=>e.tags.includes(t))))).sort((a,b)=>b.date-a.date||b.id.localeCompare(a.id));const manual=list.find(e=>e.id===this.manual);if(manual)list=[manual,...list.filter(e=>e!==manual)];const total=Math.max(1,Math.ceil(list.length/this.size));this.page=Math.min(this.page,total);this.grid.replaceChildren(...list.slice((this.page-1)*this.size,this.page*this.size).map(e=>e.node.cloneNode(true)));this.querySelector('.bdb-empty').hidden=!!list.length;this.querySelector('.bdb-pagination').hidden=total<=1;this.querySelector('[data-page-prev]').disabled=this.page<=1;this.querySelector('[data-page-next]').disabled=this.page>=total;this.querySelector('[data-page-status]').textContent=this.page+' / '+total;}
  turn(n){this.page+=n;this.render();this.querySelector('.bdb-grid').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
 }
 customElements.define('bd-blog-hub',BDBlogHub);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["db-blog-recommendations"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bd-blog-recommendations')){
 class BDBlogRecommendations extends HTMLElement{
  connectedCallback(){if(this.moving)return;this.shell=this.closest('.shopify-section');if(!this.shell)return;this.home=document.createElement('div');this.home.className='dbr-home';this.shell.before(this.home);this.media=matchMedia('(min-width: 1025px)');this.onChange=()=>this.place();this.media.addEventListener('change',this.onChange);this.onLoad=()=>this.place();document.addEventListener('shopify:section:load',this.onLoad);this.place();}
  place(){if(!this.home?.isConnected)return;let target=this.home;if(this.dataset.articlePage==='true'&&this.media.matches){const a=document.querySelector('.article-template .halo-article-block');if(a){target=a.querySelector('.halo-sidebar-wrapper');if(!target){target=a.querySelector('.dbr-created-aside');if(!target){target=document.createElement('aside');target.className='dbr-created-aside';a.prepend(target);a.classList.add('dbr-created-layout');}}}}if(this.shell.parentElement!==target){this.moving=true;target.prepend(this.shell);this.moving=false;}}
  disconnectedCallback(){if(this.moving)return;this.media?.removeEventListener('change',this.onChange);document.removeEventListener('shopify:section:load',this.onLoad);this.home?.remove();}
 }
 customElements.define('bd-blog-recommendations',BDBlogRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["db-kit-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('db-kit-builder')) return;
  class DBKitBuilder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-db-config]').textContent);
      this.words = this.querySelector('[data-db-strings]').dataset;
      this.formatter = new Intl.NumberFormat(this.config.locale, {style:'currency', currency:this.config.currency, currencyDisplay:'code'});
      this.items = this.config.items.map((item, index) => ({...item, index, selected:item.id, included:true}));
      this.initial = this.items.map(item => ({selected:item.selected, quantity:item.quantity, included:true, defaultValid:item.defaultValid}));
      this.busy = false;
      this.uncertain = false;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.addEventListener('click', event => this.click(event), options);
      this.addEventListener('change', event => this.change(event), options);
      document.addEventListener('db-kit-add', event => { if (event.detail.kit === this.dataset.kit) this.add(); }, options);
      document.addEventListener('db-kit-refresh', () => this.render(), options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target) || !event.target.closest('[data-db-row]')) return;
        const panel=this.querySelector('.dbk-editor');
        if(panel) panel.hidden=false;
        const toggle=this.querySelector('[data-db-toggle]');
        if(toggle){toggle.setAttribute('aria-expanded','true');toggle.textContent=this.words.collapse;}
        const row=event.target.closest('[data-db-row]');
        if(row){const item=this.items[Number(row.dataset.dbRow)];if(item){item.included=true;this.render();}}
      }, options);
      const dialog=this.querySelector('dialog');
      dialog?.addEventListener('close',()=>{dialog.querySelector('video')?.pause();dialog.querySelector('iframe')?.remove();},options);
      dialog?.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) dialog.close();}},options);
      document.addEventListener('click',event=>{if(!event.target.closest('[data-db-tile]'))this.querySelectorAll('.is-caption-visible').forEach(tile=>tile.classList.remove('is-caption-visible'));},options);
      const toggle = this.querySelector('[data-db-toggle]');
      if (toggle) toggle.hidden = false;
      this.querySelectorAll('[data-db-select]').forEach(select => {
        const item = this.items[Number(select.closest('[data-db-row]').dataset.dbRow)];
        const original = item.variants.find(v => v.id === item.id);
        [...select.options].forEach(option => {
          const variant = item.variants.find(v => String(v.id) === option.value);
          if (!variant) return;
          const delta = variant.price - (original?.price ?? variant.price);
          option.textContent = variant.title + (variant.id === item.id ? ` · ${this.words.original}` : delta ? ` (${delta > 0 ? '+' : '−'}${this.money(Math.abs(delta))} ${this.words.each})` : '') + (variant.available ? '' : ` · ${(this.words.soldOut || this.words.unavailable)}`);
        });
      });
      this.observer = new IntersectionObserver(entries => {
        this.pastHero = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
        this.syncSticky();
      }, {threshold:0});
      this.observer.observe(this.querySelector('.dbk-hero'));
      this.render();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.ready = false; }
    money(value) { return this.formatter.format(value / 100); }
    variant(item) { return item.variants.find(v => v.id === item.selected); }
    valid(item) {
      const v = this.variant(item);
      return item.defaultValid !== false && !!v?.available && Number.isInteger(item.quantity) && item.quantity >= item.min && item.quantity <= item.max;
    }
    summary() {
      const selected = this.items.filter(item => item.included);
      const subtotal=selected.reduce((sum,item)=>sum+(this.variant(item)?.price||0)*item.quantity,0);
      const requirements=new Map(), quantities=new Map(), members=new Set();
      this.items.forEach(item=>{if(item.discountMember!==false&&item.productId){members.add(item.productId);requirements.set(item.productId,(requirements.get(item.productId)||0)+(Number(item.discountMinimum)>0?Number(item.discountMinimum):Number(this.initial[item.index].quantity)));}});
      selected.forEach(item=>{if(this.valid(item))quantities.set(item.productId,(quantities.get(item.productId)||0)+item.quantity);});
      const complete=requirements.size>0&&[...requirements].every(([id,min])=>(quantities.get(id)||0)>=min);
      const percent=Math.max(0,Math.min(100,Number(this.config.discountPercent)||0));
      const qualified=this.config.discountActive===true&&complete;
      const groups=new Map();
      selected.filter(item=>members.has(item.productId)).forEach(item=>groups.set(item.selected,(groups.get(item.selected)||0)+(this.variant(item)?.price||0)*item.quantity));
      const savings=qualified?[...groups.values()].reduce((sum,value)=>sum+Math.round(value*percent/100),0):0;
      const unchanged=this.items.every((item,i)=>item.included===this.initial[i].included&&item.quantity===this.initial[i].quantity&&item.selected===this.initial[i].selected);
      return {subtotal,total:subtotal-savings,savings,qualified,complete,percent,unchanged,count:selected.reduce((sum,item)=>sum+item.quantity,0),valid:selected.length>0&&selected.every(item=>this.valid(item))&&this.items.every(item=>!item.required||item.included)};
    }
    targets() { return [...document.querySelectorAll('db-kit-final')].filter(element => element.dataset.kit === this.dataset.kit); }
    render() {
      const summary = this.summary();
      const roots = [this,...this.targets()];
      roots.forEach(root => {
        root.querySelectorAll('[data-db-total]').forEach(el => {
          let amount=summary.total;
          const final=root!==this;
          const ownOverride=final&&root.dataset.customPriceEnabled==='true';
          const useHero=!final||root.dataset.syncPrice!=='false';
          const override=ownOverride?root.dataset.customPrice:(useHero&&this.config.customPriceEnabled?this.config.customPrice:'');
          const normalized=String(override??'').trim();
          if(el.dataset.dbDisplay==='subtotal') amount=summary.subtotal;
          else if(summary.unchanged&&this.config.currency===this.config.shopCurrency&&/^\d+(?:\.\d{1,2})?$/.test(normalized))amount=Math.round(Number(normalized)*100);
          el.textContent=this.money(amount);
        });
        root.querySelectorAll('[data-db-discount-status]').forEach(el=>{el.hidden=!this.config.discountActive;el.textContent=summary.qualified?this.words.discountApplied.replace('[percent]',String(summary.percent)).replace('[savings]',this.money(summary.savings)):this.words.discountIncomplete;});
        root.querySelectorAll('[data-db-count]').forEach(el => { el.textContent = summary.count; });
        root.querySelectorAll('[data-db-add]').forEach(el => { el.disabled = this.busy || this.uncertain || !summary.valid; const label=el.querySelector('[data-db-button-label]') || el; label.textContent = this.busy ? this.words.adding : (el.dataset.dbLabel || this.config.cta); el.setAttribute('aria-busy', String(this.busy)); });
      });
      this.items.forEach(item => {
        const v = this.variant(item);
        const row = this.querySelector(`[data-db-row="${item.index}"]`);
        const summaryRow = this.querySelector(`[data-db-summary="${item.index}"]`);
        const tile = this.querySelector(`[data-db-tile="${item.index}"]`);
        if (!row || !summaryRow || !tile) return;
        summaryRow.hidden = !item.included;
        tile.hidden = !item.included;
        row.classList.toggle('is-removed', !item.included);
        row.querySelector('[data-db-row-controls]').hidden = !item.included;
        const qty = row.querySelector('[data-db-quantity]');
        qty.value = item.quantity;
        const select = row.querySelector('[data-db-select]');
        if (select) { select.value=String(item.selected); select.disabled=this.busy; }
        qty.disabled=this.busy;
        const minus = row.querySelector('[data-db-minus]');
        const plus = row.querySelector('[data-db-plus]');
        if (minus) minus.disabled = this.busy || item.quantity <= item.min;
        if (plus) plus.disabled = this.busy || item.quantity >= item.max;
        const remove = row.querySelector('[data-db-remove]');
        if (remove) { remove.querySelector('[data-db-remove-label]').textContent = item.included ? this.words.remove : this.words.restore; remove.disabled=this.busy; remove.setAttribute('aria-label', `${item.included ? this.words.remove : this.words.restore}: ${item.title}`); }
        row.querySelector('[data-db-line-total]').textContent = this.money((v?.price || 0)*item.quantity);
        row.querySelector('[data-db-row-error]').textContent = item.included && !this.valid(item) ? this.words.unavailable : '';
        summaryRow.querySelector('[data-db-item-quantity]').textContent = item.quantity;
        summaryRow.querySelector('[data-db-variant-name]').textContent = item.hasDefaultOnly ? '' : (v?.title || '');
        const url = item.url ? `${item.url}?variant=${item.selected}` : '#';
        [...row.querySelectorAll('[data-db-product-link]'),...summaryRow.querySelectorAll('[data-db-product-link]'),tile].forEach(link => { link.href=url; });
        const image=item.imageOverride ? item.image : (v?.image || item.image);
        if(image) [row,tile].forEach(root => { const img=root.querySelector('img'); if(img && img.getAttribute('src')!==image) {img.removeAttribute('srcset');img.src=image;} });
      });
      this.querySelectorAll('[data-db-reset]').forEach(el=>{el.disabled=this.busy;});
      if (!this.busy && !this.uncertain) {
        const invalid=this.items.filter(item=>item.included && !this.valid(item));
        this.message(invalid.length ? `${this.words.unavailable}: ${invalid.map(item=>item.title).join(', ')}` : summary.count===0 ? this.words.empty : '');
      }
      this.syncSticky();
    }
    syncSticky() { const sticky=this.querySelector('[data-db-sticky]'); if(sticky) sticky.hidden=!this.pastHero || !this.items.length; }
    message(text) { this.querySelector('[data-db-message]').textContent=text; }
    openVideo() {
      const dialog=this.querySelector('dialog'); if(!dialog || dialog.open)return;
      dialog.showModal();dialog.querySelector('video')?.play().catch(()=>{});
    }
    click(event) {
      const tile=event.target.closest('[data-db-tile]');
      if(tile && matchMedia('(hover:none), (pointer:coarse)').matches){event.preventDefault();this.querySelectorAll('[data-db-tile]').forEach(other=>{if(other!==tile)other.classList.remove('is-caption-visible');});tile.classList.toggle('is-caption-visible');return;}
      const button=event.target.closest('button');
      if (!button || button.disabled) return;
      if(button.matches('[data-db-copy-default]')){
        const helper=button.closest('.dbk-editor-variants'),field=helper.querySelector('[data-db-default-value]'),status=helper.querySelector('[data-db-copy-status]');
        field.focus();field.select();
        if(navigator.clipboard?.writeText)navigator.clipboard.writeText(field.value).then(()=>status.textContent=this.words.copySuccess).catch(()=>status.textContent=this.words.copyFallback);
        else status.textContent=this.words.copyFallback;
        return;
      }
      if(button.matches('[data-db-video-open]')){this.openVideo();return;}
      if(button.matches('[data-db-video-close]')){this.querySelector('dialog')?.close();return;}
      if(button.matches('[data-db-customization-close]')){
        this.querySelector('.dbk-editor').hidden=true;
        const toggle=this.querySelector('[data-db-toggle]');
        if(toggle){toggle.setAttribute('aria-expanded','false');toggle.textContent=this.words.customize;toggle.focus({preventScroll:true});toggle.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});}
        return;
      }
      if (button.matches('[data-db-add]')) { this.add(); return; }
      if (button.matches('[data-db-toggle]')) {
        const panel=this.querySelector('.dbk-editor'); panel.hidden=!panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
        button.textContent=panel.hidden ? this.words.customize : this.words.collapse;
        if (!panel.hidden) panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
        return;
      }
      if (this.busy || this.uncertain) return;
      if (button.matches('[data-db-reset]')) {
        this.items.forEach((item,index)=>Object.assign(item,this.initial[index])); this.render(); return;
      }
      const row=button.closest('[data-db-row]'); if(!row) return;
      const item=this.items[Number(row.dataset.dbRow)];
      if (button.matches('[data-db-remove]') && !item.required) item.included=!item.included;
      if (item.allowQuantity && button.matches('[data-db-plus]')) item.quantity=Math.min(item.max,item.quantity+1);
      if (item.allowQuantity && button.matches('[data-db-minus]')) item.quantity=Math.max(item.min,item.quantity-1);
      this.render();
    }
    change(event) {
      if (this.busy || this.uncertain) return;
      const row=event.target.closest('[data-db-row]'); if(!row) return;
      const item=this.items[Number(row.dataset.dbRow)];
      if(event.target.matches('[data-db-default-reference]')){row.querySelector('[data-db-default-value]').value=event.target.value;row.querySelector('[data-db-copy-status]').textContent='';return;}
      if(event.target.matches('[data-db-select]') && item.allowVariant) { const v=item.variants.find(v=>String(v.id)===event.target.value); if(v?.available) {item.selected=v.id;item.defaultValid=true;} }
      if(event.target.matches('[data-db-quantity]') && item.allowQuantity) { const n=Number(event.target.value); if(Number.isFinite(n)) item.quantity=Math.min(item.max,Math.max(item.min,Math.round(n))); }
      this.render();
    }
    async add() {
      if(this.busy || this.uncertain || !this.summary().valid) return;
      this.busy=true; this.render(); this.message('');
      const combined=new Map();
      this.items.filter(item=>item.included).forEach(item=>combined.set(item.selected,(combined.get(item.selected)||0)+item.quantity));
      const payload={items:[...combined].map(([id,quantity])=>({id,quantity}))};
      try {
        const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const data=await response.json();
        if(!response.ok || data.status) {
          this.uncertain=true; this.busy=false; this.render();
          this.message(`${data.description || data.message || this.words.unavailable} ${this.words.review}`);
          this.querySelector('[data-db-check-cart]').hidden=false;
          this.querySelector('[data-db-message]').scrollIntoView({block:'center'});
          return;
        }
        this.message(this.words.added);
        window.location.assign(this.config.cartUrl);
      } catch(error) {
        this.uncertain=true; this.busy=false; this.render(); this.message(this.words.network);
        this.querySelector('[data-db-check-cart]').hidden=false;
        this.querySelector('[data-db-message]').scrollIntoView({block:'center'});
      }
    }
  }
  class DBKitFinal extends HTMLElement {
    connectedCallback() {
      if(this.ready) return; this.ready=true;
      this.abort=new AbortController();
      this.addEventListener('click',event=>{if(event.target.closest('[data-db-add]')) document.dispatchEvent(new CustomEvent('db-kit-add',{detail:{kit:this.dataset.kit}}));},{signal:this.abort.signal});
      document.dispatchEvent(new CustomEvent('db-kit-refresh'));
    }
    disconnectedCallback() { this.abort?.abort(); this.ready=false; }
  }
  customElements.define('db-kit-builder',DBKitBuilder);
  customElements.define('db-kit-final',DBKitFinal);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["db-product-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('db-product-finder')) {
  customElements.define('db-product-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.questions = [...this.querySelectorAll('[data-question]')];
      this.optionMaps = this.questions.map(q => new Map([...q.querySelectorAll('[data-answer]')].map(b => [b.dataset.answer, b.dataset])));
      this.querySelector('[data-total]').textContent = String(this.questions.length).padStart(2, '0');
      if (!this.questions.length) return;
      this.answers = this.questions.map(() => []);
      this.step = 0;
      this.page = 0;
      this.matches = [];
      this.results = this.querySelector('[data-results]');
      this.grid = this.querySelector('[data-grid]');
      this.catalog = [...this.querySelectorAll('template[data-product]')];
      this.addEventListener('click', event => this.handleClick(event), { signal: this.controller.signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.questions.findIndex(q => q.dataset.question === event.detail.blockId);
        if (index < 0) return;
        this.step = index;
        this.showStep(false);
      }, { signal: this.controller.signal });
      this.mobileQuery = matchMedia('(max-width: 749px)');
      this.grid.addEventListener('scroll', () => {
        if (!this.mobile || this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          if (!this.mobile || this.results.hidden) return;
          const cards = [...this.grid.querySelectorAll('.dbpf-card')];
          const edge = this.grid.getBoundingClientRect().left;
          let nearest = 0, distance = Infinity;
          cards.forEach((card, index) => {
            const offset = Math.abs(card.getBoundingClientRect().left - edge);
            if (offset < distance) { distance = offset; nearest = index; }
          });
          this.page = nearest;
          this.updatePagination();
        });
      }, { passive: true, signal: this.controller.signal });
      this.grid.addEventListener('keydown', event => {
        if (!this.mobile || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.matches.length - 1 : this.page + (event.key === 'ArrowRight' ? 1 : -1);
        this.goToPage(target);
      }, { signal: this.controller.signal });
      this.mobileQuery.addEventListener('change', () => this.updateLayout(), { signal: this.controller.signal });
      this.observer = new ResizeObserver(() => this.updateLayout());
      this.updateLayout();
      this.observer.observe(this);
      this.showStep(false);
      this.sync();
      this.querySelector('[data-wizard]').hidden = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.layoutFrame);
      this.controller = null;
    }
    track(action, detail = {}) {
      this.dispatchEvent(new CustomEvent('db:finder', { bubbles: true, detail: { action, sectionId: this.id, ...detail } }));
    }
    handleClick(event) {
      const button = event.target.closest('button');
      const productLink = event.target.closest('[data-result-link]');
      if (productLink) this.track('product_click', { productId: productLink.dataset.resultLink });
      if (!button || button.disabled || !this.contains(button)) return;
      if (button.hasAttribute('data-answer')) {
        const qi = this.questions.indexOf(button.closest('[data-question]'));
        const value = button.dataset.answer;
        let answer = this.answers[qi];
        if (qi < 0) return;
        const max = Math.max(1, Number(this.questions[qi].dataset.max) || 1);
        if (answer.includes(value)) answer = answer.filter(x => x !== value);
        else if (max === 1 || button.dataset.ignore === 'true') answer = [value];
        else {
          answer = answer.filter(x => this.optionMaps[qi].get(x)?.ignore !== 'true');
          if (answer.length >= max) {
            this.querySelector('[data-status]').textContent = this.dataset.limitMessage.replace('{count}', String(max));
            return;
          }
          answer = [...answer, value];
        }
        if (!this.started) { this.started = true; this.track('start'); }
        this.answers[qi] = answer;
        this.querySelector('[data-status]').textContent = '';
        this.invalidate();
        this.sync();
        if (this.activeSelections()) this.revealActions();
      }
      if (button.hasAttribute('data-prev')) { this.step--; this.showStep(); }
      if (button.hasAttribute('data-next')) { this.step++; this.showStep(); }
      if (button.hasAttribute('data-clear')) this.clear();
      if (button.hasAttribute('data-find')) this.find();
      if (button.hasAttribute('data-page-prev')) this.goToPage(this.page - 1);
      if (button.hasAttribute('data-page-next')) this.goToPage(this.page + 1);
    }
    revealActions() {
      if (!matchMedia('(max-width: 749px)').matches) return;
      const actions = this.querySelector('.dbpf-actions');
      const rect = actions.getBoundingClientRect();
      const viewport = window.visualViewport;
      const top = viewport ? viewport.offsetTop : 0;
      const height = viewport ? viewport.height : window.innerHeight;
      if (rect.bottom > top + height - 112 || rect.top < top + 80) {
        actions.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
    }
    selectedOptions(index) {
      return this.answers[index].map(id => this.optionMaps[index].get(id)).filter(option => option && option.ignore !== 'true');
    }
    activeSelections() { return this.questions.some((_, index) => this.answers[index].some(id => this.optionMaps[index].has(id))); }
    sync() {
      this.questions.forEach((q, i) => q.querySelectorAll('[data-answer]').forEach(b => b.setAttribute('aria-pressed', String(this.answers[i].includes(b.dataset.answer)))));
      this.querySelector('[data-clear]').hidden = !this.answers.some(x => x.length);
      this.querySelector('[data-find]').disabled = !this.activeSelections();
      this.querySelector('[data-find]').setAttribute('aria-expanded', String(!this.results.hidden));
    }
    showStep(focus = true) {
      this.step = Math.max(0, Math.min(this.questions.length - 1, this.step));
      this.questions.forEach((q, i) => { q.hidden = i !== this.step; });
      this.querySelector('[data-prev]').disabled = this.step === 0;
      this.querySelector('[data-next]').disabled = this.step === this.questions.length - 1;
      this.querySelector('[data-step]').textContent = String(this.step + 1).padStart(2, '0');
      this.querySelector('[data-progress]').style.width = `${(this.step + 1) / this.questions.length * 100}%`;
      this.querySelector('[data-status]').textContent = '';
      if (focus) this.questions[this.step].querySelector('legend').focus({ preventScroll: true });
    }
    invalidate() {
      if (!this.results.hidden) {
        this.results.hidden = true;
        this.matches = [];
        this.grid.replaceChildren();
        this.querySelector('[data-status]').textContent = this.dataset.changedMessage;
      }
    }
    clear() {
      this.answers = this.questions.map(() => []);
      this.matches = [];
      this.results.hidden = true;
      this.grid.replaceChildren();
      this.step = 0;
      this.started = false;
      this.showStep();
      this.sync();
      this.track('clear');
    }
    optionMatches(item, option, rule) {
      if (rule === 'products') return (option.products || '').split(',').includes(item.dataset.product);
      const min = Number(option.min), max = Number(option.max);
      if (!Number.isFinite(min) || min < 0) return false;
      if (rule === 'depth') return Number(item.dataset.depth) > 0 && Number(item.dataset.depth) >= min;
      if (rule === 'lumens') {
        const value = Number(item.dataset.lumens);
        if (!Number.isFinite(max) || max < 0 || (max > 0 && max <= min)) return false;
        return value > 0 && value >= min && (max === 0 || value < max);
      }
      return false;
    }
    passes(item) {
      return this.questions.every((question, index) => {
        const options = this.selectedOptions(index);
        const rule = question.dataset.rule;
        if (!options.length || rule === 'preference') return true;
        const test = option => this.optionMatches(item, option, rule);
        return question.dataset.combine === 'all' ? options.every(test) : options.some(test);
      });
    }
    preferenceScore(item, candidates) {
      const metrics = { bright: ['lumens', false], runtime: ['runtime', false], compact: ['volume', true], light: ['weight', true], distance: ['distance', false], cri: ['cri', false] };
      let score = 0;
      this.questions.forEach((question, index) => {
        if (question.dataset.rule !== 'preference') return;
        this.selectedOptions(index).forEach(option => {
          const preference = option.metric || 'manual';
          if (preference === 'manual') {
            if ((option.products || '').split(',').includes(item.dataset.product)) score += 1;
            return;
          }
          if (preference === 'replaceable' || preference === 'simple') {
            if (item.dataset[preference] === 'true') score += 1;
            return;
          }
          if (!metrics[preference]) return;
          const [key, lower] = metrics[preference];
          const value = Number(item.dataset[key]);
          const values = candidates.map(p => Number(p.dataset[key])).filter(v => Number.isFinite(v) && v > 0);
          if (!(value > 0) || !Number.isFinite(value) || !values.length) return;
          const min = Math.min(...values), max = Math.max(...values);
          score += max === min ? 1 : lower ? (max - value) / (max - min) : (value - min) / (max - min);
        });
      });
      return score;
    }
    find() {
      if (!this.activeSelections()) return;
      const seen = new Set();
      const candidates = this.catalog.filter(p => {
        if (seen.has(p.dataset.product) || !this.passes(p)) return false;
        seen.add(p.dataset.product);
        return true;
      });
      this.matches = candidates.map((item, index) => ({ item, index, score: this.preferenceScore(item, candidates) }))
        .sort((a, b) => b.score - a.score || a.index - b.index).slice(0, Number(this.dataset.maxResults)).map(x => x.item);
      this.page = 0;
      this.results.hidden = false;
      this.querySelector('[data-status]').textContent = '';
      this.renderProducts();
      this.sync();
      this.track('find', { count: candidates.length, answers: this.answers.map(a => [...a]) });
      if (!candidates.length) this.track('no_results');
      this.results.querySelector('[data-result-heading]').focus({ preventScroll: true });
      this.results.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
    updateLayout() {
      const width = this.getBoundingClientRect().width;
      const mobile = this.mobileQuery.matches;
      const perPage = mobile ? 1 : width < 600 ? 1 : width < 960 ? 2 : Number(this.dataset.columns);
      const changed = this.mobile !== mobile || this.perPage !== perPage;
      const first = this.page * (this.perPage || 1);
      this.mobile = mobile;
      this.perPage = perPage;
      if (changed) {
        this.page = Math.floor(first / perPage);
        if (!this.results.hidden) this.renderProducts();
      } else if (mobile && width !== this.layoutWidth && !this.results.hidden) {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.scrollToPage(false));
      }
      this.layoutWidth = width;
      this.positionArrows();
    }
    goToPage(page) {
      const pages = Math.max(1, Math.ceil(this.matches.length / this.perPage));
      this.page = Math.max(0, Math.min(pages - 1, page));
      if (this.mobile) {
        this.scrollToPage(true);
        this.updatePagination();
      } else this.renderProducts(true);
    }
    scrollToPage(smooth) {
      const card = this.grid.querySelectorAll('.dbpf-card')[this.page];
      if (!card) return;
      const left = this.grid.scrollLeft + card.getBoundingClientRect().left - this.grid.getBoundingClientRect().left;
      this.grid.scrollTo({ left, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    updatePagination() {
      const pages = Math.max(1, Math.ceil(this.matches.length / this.perPage));
      const prev = this.querySelector('[data-page-prev]'), next = this.querySelector('[data-page-next]');
      prev.hidden = next.hidden = pages <= 1;
      prev.disabled = this.page === 0;
      next.disabled = this.page === pages - 1;
      const counter = this.querySelector('[data-page-count]');
      counter.hidden = pages <= 1;
      const text = `${this.page + 1} / ${pages}`;
      if (counter.textContent !== text) counter.textContent = text;
    }
    renderProducts(focus = false) {
      const count = this.matches.length;
      const pages = Math.max(1, Math.ceil(count / this.perPage));
      this.page = Math.max(0, Math.min(pages - 1, this.page));
      this.querySelector('[data-empty]').hidden = count > 0;
      this.querySelector('[data-carousel]').hidden = !count;
      const heading = this.querySelector('[data-result-heading]');
      heading.textContent = count ? this.dataset.resultsTitle : this.dataset.emptyTitle;
      const fragment = document.createDocumentFragment();
      const products = this.mobile ? this.matches : this.matches.slice(this.page * this.perPage, (this.page + 1) * this.perPage);
      products.forEach(p => fragment.append(p.content.cloneNode(true)));
      this.grid.replaceChildren(fragment);
      this.grid.toggleAttribute('data-single', count <= 1);
      this.grid.style.setProperty('--db-columns', Math.max(1, products.length));
      if (this.mobile) this.scrollToPage(false);
      else this.grid.scrollLeft = 0;
      this.updatePagination();
      this.positionArrows();
      if (focus) heading.focus({ preventScroll: true });
    }
    positionArrows() {
      const media = this.grid.querySelector('.dbpf-media');
      if (media) this.querySelector('[data-carousel]').style.setProperty('--db-arrow-top', `${media.getBoundingClientRect().height / 2}px`);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-show');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            if(this.headerIsAlwaysSticky != 'always'){
                                this.header.classList.add('shopify-section-header-hidden');
                            }
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
        this.header = document.querySelector('.section-header-navigation');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        }

        setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
        }

        onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');

            if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
            } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            document.body.classList.remove('scrolled-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
        this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
            }
        }

        closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            //   if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
            //       if (document.body.classList.contains('template-index')) {
            //           if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
            //               $('.vertical-menu').removeClass('vertical-menu__hide');
            //           }
            //       }
            //   }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
